import clsx from 'clsx';

import type { TextProps } from 'components/atoms/Text';
import Text from 'components/atoms/Text';
import { twMerge } from '../../../../../utils/twMerge';

export interface Props extends TextProps {
  children: React.ReactNode;
}

export const Title = ({ className, ...restProps }: Props) => {
  return (
    <Text
      as="h2"
      className={twMerge(clsx('mb-sm1', className))}
      variant="headerRegular"
      {...restProps}
    />
  );
};
